import type { DriftType } from "../../../types";

export function getClassForPeadChart(
	showSeasonal: boolean,
	type: DriftType,
	qtr: DriftType,
	driftUnitValue?: DriftType,
) {
	return (showSeasonal && driftUnitValue === qtr) ||
		(!showSeasonal && driftUnitValue === type)
		? "active"
		: "";
}
